import React from 'react';
import { useShippingSimulator } from '../hooks/useShippingSimulator';

type ShippingContainerProps = { children: React.ReactNode };

const ShippingContainer = ({ children }: ShippingContainerProps) => {
	const { componentId } = useShippingSimulator();
	return (
		<div
			data-selection={componentId}
			className="shippingContainer vtex-store-components-3-x-shippingContainer t-small c-on-base"
		>
			{children}
		</div>
	);
};

export default ShippingContainer;
